import { FarrisPropConfigWithData } from "@edp-pmf/grapheditor";
import { MxGraphNS } from "@edp-pmf/mxgraph-ts";
import { OperationActivity } from "@gsp-wf/wf-process-model";
import { UserActivityCell } from "./UserActivityCell";
import { BpmnModelHelper, FlowNodeState } from "@edp-pmf/bpmn-model";
import { WfConstants } from "../WfConstants";

/**
 * 人工操作活动节点
 */
export class OperationActivityCell extends UserActivityCell {
    clrTypeId: string = OperationActivityCell.CLR_TYPE_ID;
    name: string = "人工操作";
    nameLanguage: { [lang: string]: string; } = {
      "zh-CHS": "人工操作",
      "zh-CHT": "人工操作",
      "en": "Operation",
  };
    static CLR_TYPE_ID: string = OperationActivity.Clr_Type_ID;
    flowElement: OperationActivity;

    imgUrls = {
        [FlowNodeState.Default]: WfConstants.IMAGE_PATH + "/bizActivity.png",
        [FlowNodeState.Selected]: WfConstants.IMAGE_PATH + "/bizActivity_select.svg",
    };

    constructor(value?: any, geometry?: MxGraphNS.mxGeometry, style?: string) {
        super(value, geometry, style);
    }

    createFlowElement(flowElt?: OperationActivity) {
        const flowNode = super.createFlowElement(flowElt) as OperationActivity;
        return flowNode;
    }

    getFarrisPropConfig(): FarrisPropConfigWithData {
        return this.getFarrisPropConfigByIsOperation(true);
    }

    updateProps(obj: any): void {
        this.updatePropsByIsOperation(obj, true);
    }
}
